"use client"

import { Icon, type IconName } from "@/components/marketplace/icon-map"
import { Text } from "@/components/ui"
import { useAutoRotate } from "@/lib/hooks/use-auto-rotate"

interface TrustProof {
  icon: IconName
  label: string
  sub?: string
}

export const TrustPills = ({ title, items }: { title?: string; items: TrustProof[] }) => {
  const { index, pauseProps } = useAutoRotate(items.length, 3500)
  return (
    <div
      className="bg-brand rounded-10x text-fg-inverted flex flex-col items-center gap-125 px-400 py-250 @2xl:px-500 @4xl:flex-row @4xl:items-center @4xl:justify-between @4xl:gap-400 @4xl:rounded-full @4xl:py-350"
      {...pauseProps}
    >
      {title && (
        <Text as="p" variant="body" family="text" tone="inverted" className="text-copy @2xl:text-copy-lg text-center font-medium @4xl:text-left">
          {title}
        </Text>
      )}
      <ul className="grid shrink-0 grid-cols-1 grid-rows-1 justify-items-center gap-125 motion-reduce:flex motion-reduce:flex-wrap motion-reduce:justify-center @2xl:flex @2xl:flex-wrap @2xl:items-center @2xl:justify-center @4xl:flex-nowrap @4xl:justify-start">
        {items.map((item, itemIndex) => (
          <li
            key={item.label}
            className={`ring-fg-inverted text-fg-inverted duration-moderate ease-productive col-start-1 row-start-1 inline-flex h-6 items-center gap-125 rounded-full px-200 ring-1 transition-opacity ring-inset motion-reduce:opacity-100 motion-reduce:transition-none @2xl:h-6.5 @2xl:opacity-100 ${itemIndex === index ? "opacity-100" : "opacity-0"}`}
          >
            <Icon name={item.icon} size={16} />
            <Text as="span" variant="body" family="text" tone="inverted" className="text-copy @2xl:text-copy-lg">
              {item.label}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  )
}
